export enum TransactionDate {
  Created = 'Created',
  Settled = 'Settled',
}
